import { CAMPAIGN_DOCUMENT_LINK_FILE_TYPE, CampaignDocument } from '../../model/campaign'

// Countries follow the campaign-documents convention: full country names
// joined by commas (see mapDocumentFromRawData and buildLinkCreateParams).
const readCountries = (rawCountries: unknown): string[] => {
  const value = rawCountries ? String(rawCountries).trim() : ''

  return value ? value.split(',') : []
}

// Maps a campaign-links procedure row (spLutCampaignLinks*) to the shared
// campaign document model. Links live in their own table, so the row carries
// no file content; the kind marker is set here rather than read from the row.
// Field names tolerate both the documents-style aliases (FileName/FileLink)
// and the table's own names (Title/Url).
export const mapLinkFromRawData = (rawData: any): CampaignDocument => ({
  entryId: rawData.EntryId ?? rawData.Id,
  campaignId: rawData.CampaignId,
  fileName: rawData.FileName ?? rawData.Title,
  fileLink: rawData.FileLink ?? rawData.Url,
  fileType: CAMPAIGN_DOCUMENT_LINK_FILE_TYPE,
  file: rawData.File,
  countries: readCountries(rawData.Countries),
  isVisible: Boolean(rawData.IsVisible),
  created: rawData.Created,
  createdBy: rawData.CreatedBy,
  modified: rawData.Modified,
  modifiedBy: rawData.ModifiedBy,
})
